<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
>
  @let header = globalDataService.config().header;
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>
  @let heroBanner = pageConfig().components.heroBanner;
  <app-hero-banner
    [enabled]="!!heroBanner?.enabled"
    [styles]="heroBanner?.data?.styles"
    [quantity]="heroBanner?.data?.quantity"
    [imageToggle]="heroBanner?.data?.imageToggle"
    [imageSrcData]="heroBanner?.data?.imageSrcData"
    [bannerSize]="heroBanner?.data?.bannerSize"
    [mainText]="heroBanner?.data?.mainText"
    [mainTextSize]="heroBanner?.data?.mainTextSize"
    [subText]="heroBanner?.data?.subText"
    [ctaText]="heroBanner?.data?.ctaText"
    [bannerAltText]="heroBanner?.data?.bannerAltText"
  ></app-hero-banner>
  @defer {
    @let featuredCarousel = pageConfig().components.featuredCarousel;
    <app-featured-carousel
      [enabled]="!!featuredCarousel?.enabled"
      [currencyCode]="globalData.selectedCurrency().code"
      [assetCardDefaultImage]="globalData.defaultImage()"
      [assetCardConfig]="featuredCarousel?.data?.components?.assetCard"
      (cardClick)="cardClicked($event)"
      (contactClick)="contactClicked($event)"
    ></app-featured-carousel>
    @let browseByCategory = pageConfig().components.browseByCategory;
    <app-browse-by-category
      [enabled]="!!browseByCategory?.enabled"
      [styles]="browseByCategory?.data?.styles"
      [quantity]="browseByCategory?.data?.quantity"
      [display]="browseByCategory?.data?.display"
    ></app-browse-by-category>
    @let browseByMake = pageConfig().components.browseByMake;
    <app-browse-by-make
      [enabled]="!!browseByMake?.enabled"
      [styles]="browseByMake?.data?.styles"
      [quantity]="browseByMake?.data?.quantity"
      [showImages]="browseByMake?.data?.display"
    ></app-browse-by-make>
    @let contactFormSection = pageConfig().components.contactFormSection;
    <app-section
      [enabled]="!!contactFormSection?.enabled"
      [mainText]="contactFormSection?.data?.mainText"
      [mainTextSize]="contactFormSection?.data?.mainTextSize"
      [subText]="contactFormSection?.data?.subText"
      [styles]="contactFormSection?.data?.styles"
    >
      @let generalConfig = globalDataService.config().general;
      @let contactFormConfig = globalDataService.config().contactForm;
      <app-contact-form
        [withCloseButton]="false"
        [successTitle]="contactFormConfig?.data?.successTitle"
        [successBody]="contactFormConfig?.data?.successBody"
        [acknowledgementEnabled]="generalConfig?.data?.contact_form_acknowledgement_enabled ?? false"
        [customAcknowledgementText]="generalConfig?.data?.custom_acknowledgement_text ?? ''"
      ></app-contact-form>
    </app-section>
  }
  @let footer = globalDataService.config().footer;
  <app-footer
    [styles]="footer.data.styles"
    [address]="footer.data.address"
    [address_line_2]="footer.data.address_line_2"
    [phone]="footer.data.phone"
    [email]="footer.data.email"
    [facebook]="footer.data.facebook"
    [twitter]="footer.data.twitter"
    [instagram]="footer.data.instagram"
    [youtube]="footer.data.youtube"
    [linkedin]="footer.data.linkedin"
    [copyright_text]="footer.data.copyright_text"
    [link_1_text]="footer.data.link_1_text"
    [link_1_url]="footer.data.link_1_url"
    [link_2_text]="footer.data.link_2_text"
    [link_2_url]="footer.data.link_2_url"
    [link_3_text]="footer.data.link_3_text"
    [link_3_url]="footer.data.link_3_url"
  ></app-footer>
</div>